export default __webpack_public_path__ + "static/media/ITOAM-booked.dd63c334.svg";